import { render } from "./AddSourse.vue?vue&type=template&id=9c94593a"
import script from "./AddSourse.vue?vue&type=script&lang=js"
export * from "./AddSourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__